import React, { useEffect, useState } from 'react';
import api from '../api';

function Transactions() {
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    api.get('/api/assets/transactions')
      .then(res => setTransactions(res.data))
      .catch(err => console.error('Transactions fetch error:', err));
  }, []);

  return (
    <div>
      <h2>Transaction History</h2>
      <div className="table-box">
        <table>
          <thead>
            <tr>
              <th>Type</th>
              <th>Amount</th>
              <th>Currency</th>
              <th>From</th>
              <th>To</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map(tx => (
              <tr key={tx.id}>
                <td style={{ color: tx.type === 'deposit' ? 'green' : 'red' }}>
                  {tx.type}
                </td>
                <td>{tx.amount}</td>
                <td>{tx.currency || 'ETH'}</td>
                <td>{tx.fromAddress?.slice(0, 8)}...</td>
                <td>{tx.toAddress?.slice(0, 8)}...</td>
                <td>{new Date(tx.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Transactions;